import React from 'react'
import { AMAZON_GEO_DOCS_URL } from 'types'

const propTypes = {}
const defaultProps = {}

function SafariIPhoneDocs() {
  const settingsApp = `${AMAZON_GEO_DOCS_URL}/iPhone-settings-app.png`
  const privacySecurity = `${AMAZON_GEO_DOCS_URL}/iPhone-privacy-security.png`
  const locationServices = `${AMAZON_GEO_DOCS_URL}/iPhone-location-services.png`
  const safariLocationOptions = `${AMAZON_GEO_DOCS_URL}/iPhone-safari-location-options.png`
  const safariLocationPrompt = `${AMAZON_GEO_DOCS_URL}/iPhone-safari-location-prompt.png`
  const safariRefresh = `${AMAZON_GEO_DOCS_URL}/iPhone-safari-refresh.png`
  return (
    <div>
      <h1 className="mr-auto margin-top-20">For Safari iPhones:</h1>
      <h3 className="mr-auto margin-top-20">
        1. You will need to change the location settings in your iPhone's
        Settings app. First, go to your iPhone's home screen and tap on the
        "Settings" app.
      </h3>
      <h3 className="mr-auto margin-top-20">
        2. Scroll down and tap on the "Privacy & Security" setting.
      </h3>
      <img
        alt="iPhone settings app, showing the privacy & security option"
        src={settingsApp}
        className="geo-doc-img"
      />
      <h3 className="mr-auto margin-top-20">
        3. Then, tap on "Location Services."
      </h3>
      <img
        alt="Privacy & Security menu, showing the location services option"
        src={privacySecurity}
        className="geo-doc-img"
      />
      <h3 className="mr-auto margin-top-20">
        4. Next, tap on "Safari Websites" to open the Safari specific location
        settings.
      </h3>
      <img
        alt="Location Services menu, showing the safari websites option"
        src={locationServices}
        className="geo-doc-img"
      />
      <h3 className="mr-auto margin-top-20">
        5. Select the "While Using the App" option so that Safari will have
        access to your location and make sure "Precise Location" is enabled.
      </h3>
      <img
        alt="Safari websites location settings, showing the different options available"
        src={safariLocationOptions}
        className="geo-doc-img"
      />
      <h3 className="mr-auto margin-top-20">
        6. Now, you can close the Settings app and go back to the Work Order
        page. You will need to refresh the page for the location settings to
        take effect. Click the refresh button next to the URL bar:
      </h3>
      <img
        alt="Safari, showing the refresh button"
        src={safariRefresh}
        className="geo-doc-img"
      />
      <h3 className="mr-auto margin-top-20">
        7. When you Check In or Check Out, you may be asked to allow location
        for this specific site. Tap "Allow" to provide your location. If you
        select "Don't Allow," you'll need to refresh the page in order to try
        again.
      </h3>
      <img
        alt="TSS Work Order page, showing the location permission prompt"
        src={safariLocationPrompt}
        className="geo-doc-img"
      />
      <h3 className="mr-auto margin-top-20">
        8. Please tap on "Back" at the top of your screen to get back to the
        Work Order page where you can Check In or Check Out.
      </h3>
    </div>
  )
}

SafariIPhoneDocs.propTypes = propTypes
SafariIPhoneDocs.defaultProps = defaultProps

export default React.memo(SafariIPhoneDocs)
